import { useEffect, useState } from "react"
import CustomButton from "../../../components/CustomButton"
import CustomDialog from "../../../components/CustomDialog"
import { List, ListItem, ListItemButton, Stack, Typography, useMediaQuery, useTheme } from "@mui/material"
import ServicesSummary from "../../../containers/ServicesSummary"
import moment from "moment"
import { DATE_TIME_FORMAT } from "../../../config/const"
import { useSelector } from "react-redux"

const ServiceSummaryList = ({ clientData }) => {
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const data = useSelector((state) => state?.biz?.data);

    const [summaryData, setSummaryData] = useState({ open: false, callId: null })
    const [selected, setSelected] = useState(null)
    const [list, setList] = useState([])

    useEffect(() => {
        if (clientData?.serviceList?.length > 0)
            setList(clientData?.serviceList?.slice().sort((a, b) => {
                return moment(b.workDt).diff(moment(a.workDt));
            }))
    }, [clientData]);

    const onClose = () => {
        setSummaryData(false)
    }

    const onClick = (callId) => {
        setSummaryData({ open: true, callId: callId })
        setSelected(callId)
    }

    return (
        <Stack padding={1}>
            <List>
                {list?.map((service, idx) => {
                    return (
                        <ListItem
                            key={idx}
                            sx={{
                                padding: 0,
                                marginY: 1,
                                bgcolor: selected === service?._id
                                    ? 'secondary.dark'
                                    : 'background.paper'
                            }}
                        >

                            <ListItemButton sx={{ px: 1 }}>
                                <Stack
                                    width='100%'
                                    direction='row'
                                    alignItems='center'
                                    justifyContent='space-between'
                                    onClick={() => setSelected(service?._id)}
                                >
                                    <Typography fontWeight='bold'>
                                        {service?.callId}
                                    </Typography>
                                    <Typography fontWeight='bold' >
                                        {service?.workDt
                                            ? moment(service?.workDt).format(DATE_TIME_FORMAT)
                                            : ""
                                        }
                                    </Typography>

                                    <CustomButton
                                        title='OPEN'
                                        onClick={() => onClick(service?._id)}
                                    />
                                </Stack>
                            </ListItemButton>
                        </ListItem>
                    )
                }
                )}
            </List>

            <CustomDialog
                title='SERVICES_SUMMARY'
                open={summaryData?.open}
                fullWidth={isMobile}
                onClose={onClose}>
                <Stack minWidth={isMobile ? 'auto' : 450}>
                    <ServicesSummary
                        bizData={{
                            bizName: data?.biz?.name,
                            bizTel: data?.biz?.tel,
                            bizAddr: data?.biz?.addr,
                            bizEmail: data?.biz?.email,
                        }}
                        callId={summaryData?.callId}
                    />
                </Stack>
            </CustomDialog>
        </Stack>

    )
}
export default ServiceSummaryList